import React from 'react'

export default (props) => (
    <div className="loader-gif">
        <img width="20%" src="./create-events-app/assets/images/loader.gif" alt=""/>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/LoaderGif/index.js